import React, { useState } from "react";
import "./style.css";
import Modal from "react-bootstrap/Modal";
import {
  DateStringFormat,
  formatTime,
} from "../../../shared/helper/helper.service";

const ErrorModal = (props) => {
  const { show, handleClose, txt} = props;

  return (
    <Modal show={show} onHide={handleClose} centered className="error-modal">
      <div className="errormodal-topview">
        <img src={require("../../../asstes/images/remove.png")} />
        <p>
          Sorry, there are no slots available for the selected {txt}. Please
          select another {txt} or call us on 8291222022 to get assistance in
          getting appropriate care.
        </p>
        <button className="Close-btn" onClick={handleClose}>
        Close
        </button>
      </div>
    </Modal>
  );
};

export default ErrorModal;
